import type { Resource } from '@/db/types'
import { compact, conflict, invalid } from '@/kinds/kind'
import { formatTime } from '@/lib/time'
import { DEFAULT_WORKSPACE_ID, type WorkspaceSpec, type WorkspaceStatus } from './schema'

export type WorkspaceResource = Resource<WorkspaceSpec, WorkspaceStatus>

export const defaults = (spec: Partial<WorkspaceSpec>): WorkspaceSpec => ({ name: '', slug: '', colour: 'sky', packs: [], order: 0, ...spec })

export const validate = (r: WorkspaceResource): string[] => (r.spec.slug === '*' ? ['slug is reserved'] : [])

export const initialStatus = (): WorkspaceStatus => ({})

export const displayName = (r: WorkspaceResource) => r.spec.name

/** Mirrors internal/kinds/workspace Apply. */
export const apply = (r: WorkspaceResource, action: string, _args: unknown, at: string): WorkspaceResource => {
  const st: WorkspaceStatus = { ...r.status }
  switch (action) {
    case 'archive':
      if (r.id === DEFAULT_WORKSPACE_ID) throw invalid('the default suite cannot be removed')
      if (st.archived_at) throw conflict('that suite is already removed')
      st.archived_at = formatTime(new Date(at))
      break
    case 'restore':
      if (!st.archived_at) throw conflict('that suite is not removed')
      st.archived_at = undefined
      break
    default:
      throw invalid(`unknown action ${action}`)
  }
  return { ...r, status: compact(st) }
}
